import PropTypes from 'prop-types';
import React, { Component } from 'react';
import _ from 'lodash';
import { connect } from 'react-redux';
import Translate from 'client/components/translate';
import Button from 'client/components/button/button';
import InputGroup from 'client/components/form/inputGroup';
import { email } from 'web-core/src/utils/validate';
import { requestReset } from 'client/actions/user';
import LinkReplace from 'client/components/button/linkReplace';
import Hero from './hero';

const mapStateToProps = state => ({
  brandName: state.brand,
});

const propTypes = {
  /* eslint-disable react/forbid-prop-types */
  location: PropTypes.object.isRequired,
  brandName: PropTypes.string.isRequired,
  requestReset: PropTypes.func.isRequired,
  // router: PropTypes.object.isRequired,
};

class RequestResetPage extends Component {
  constructor(props) {
    super(props);
    this.state = {
      submitted: false,
      username: {
        value: '',
        error: null,
      },
    };
  }

  validateUsername(state, username) {
    const newState = {
      username: {
        error: null,
      },
    };
    if (!username) {
      newState.username.error = { path: 'common.form.error.required' };
    } else if (!email.test(username)) {
      newState.username.error = { path: 'common.error.invalidEmail' };
    }
    return this.mergeVals(state, newState);
  }

  mergeVals(state, newVals) {
    return _.merge({}, state, newVals);
  }

  handleSubmit = (e) => {
    e.preventDefault();
    const username = this.state.username.value;
    const validation = this.validateUsername(this.state, username);
    const { redirect, source } = this.props.location.query;
    if (!validation.username.error) {
      return this.props
        .requestReset({
          email: username,
          redirect,
          source,
        })
        .then(() => {
          this.setState({ submitted: true });
        });
    }
    return false;
  };

  renderForm() {
    const { username } = this.state;
    return (
      <div className="pad-x-small-only">
        <h4>
          <Translate
            path={`common.account.requestReset.hero.${
              this.state.submitted ? 'success' : 'initial'
            }`} />
        </h4>
        <InputGroup
          id="username"
          label={{
            path: 'common.label.email',
          }}
          type="text"
          value={username.value}
          onChange={(e) => {
            const newVal = e.target.value;
            let newState = this.mergeVals(this.state, { username: { value: newVal } });
            if (username.error) {
              newState = this.validateUsername(newState, newVal);
            }
            this.setState(newState);
          }}
          onBlur={() => {
            this.setState(this.validateUsername(this.state, username.value));
          }}
          error={username.error} />
        <div className="text-center">
          <Button className="cta-button" clickHandler={this.handleSubmit}>
            <Translate path="common.account.reset.cta" />
          </Button>
        </div>
      </div>
    );
  }

  renderConfirmation() {
    return (
      <div className="text-center">
        <p>
          <Translate
            path="common.account.requestReset.confirmation"
            using={{ email: this.state.username.value }} />
        </p>
      </div>
    );
  }

  render() {
    return (
      <div className="account-page">
        <Hero brandName={this.props.brandName} />
        <div className="center-col" style={{ paddingBottom: '4rem' }}>
          <div className="form-container pad-y-2 medium-margin-top-2">
            <div className="center-col-small pad-x-small-only">
              {this.state.submitted ? this.renderConfirmation() : this.renderForm()}
            </div>
          </div>
          <div className="margin-top-2 pad-top-2 text-center">
            <LinkReplace
              className="transparent blue-color"
              to={{
                pathname: '/login',
                query: this.props.location.query,
              }}>
              <Translate path="common.account.requestReset.changeCtaLink" />
            </LinkReplace>
          </div>
        </div>
      </div>
    );
  }
}
RequestResetPage.propTypes = propTypes;

export default connect(
  mapStateToProps,
  {
    requestReset,
  },
)(RequestResetPage);
